import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import "./style.scss";
import CancelIcon from '@material-ui/icons/Cancel';
import { useDispatch, useSelector } from "react-redux";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { addAppointmentLabtestRequest, editAppointmentLabtestRequest, getLabtestsListRequest } from "../../store/appointments/actions";


const SuggessionForm = ({ intl: { messages }, show, close, selectedTest, patientId }) => {
     const lang = localStorage.getItem("lang") || "en";
     const dispatch = useDispatch();
     const { addedApp, labtests } = useSelector((state) => state.appointments);
     const [feedBack, setFeedBack] = useState(null);
     const [showConfirmation, setShowConfirmation] = useState(false);
     const [selectedLabtest, setSelectedLabtest] = useState(null);
     const [inputValue, setInputValue] = useState(null);
     const [labsList, setLabsList] = useState([]);

    useEffect(() => {
        dispatch(getLabtestsListRequest());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        if (labtests) {
            setLabsList(labtests.map((lab) => {
                return {
                    id: lab.id,
                    name: lang === "ar" ? `${lab.name?.ar}-${lab.reference_lab.ar}` : `${lab.name?.en}-${lab.reference_lab.en}`,
                };
            }));
        }
    }, [labtests, lang]);

     const [formData, setFormData] = useState({
        id: null,
        patient_id: null,
        lab_test_id: 0,
        lab_test_name: "",
        notes: '',
     });
   
    const clear = () => {
        setFormData({
            id: null,
            patient_id: patientId,
            lab_test_id: 0,
            lab_test_name: "",
            notes: '',
        });
        setSelectedLabtest(null);
        setFeedBack(null);
    }

    useEffect(() => {
        if (patientId) {
            setFormData({ ...formData, patient_id: patientId });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [patientId]);

    useEffect(() => {
        if (selectedTest) {
            setSelectedLabtest(selectedTest.lab_test_id);
            setInputValue(labsList.find((lab) => lab.id === selectedTest.lab_test_id).name);
            setFormData({
                id: selectedTest.id,
                patient_id: patientId,
                lab_test_id: selectedTest.lab_test_id,
                lab_test_name: selectedTest.lab_test_name,
                notes: selectedTest.notes,
            });
        } else {
            clear();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTest]);

    //AutoComplete Selection change
    useEffect(() => {
        if (selectedLabtest) {
            setFormData({ ...formData, lab_test_id: selectedLabtest.id });
        } else {
            setFormData({ ...formData, lab_test_id: 0 });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedLabtest]);

     //Clear and close
     useEffect(() => {
        if (addedApp) {
            clear();
            close();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addedApp]);

    const save = () => {
        if (!formData.patient_id) {
            setFeedBack('No Patient Selected');
            return;
        }
        if (formData.lab_test_id === 0) {
            setFeedBack(messages.appointments.app_test_required);
            return;
        }

        if (selectedTest) {
            dispatch(editAppointmentLabtestRequest({ ...formData, lab_test_id: selectedLabtest}));
        } else {
            dispatch(addAppointmentLabtestRequest({ ...formData, lab_test_id: selectedLabtest}));
        }
    }

    return (
        <div className={`test-modal_container ${show && " show"} ${lang === 'ar' && 'rtlPosition'}`}>
            <div className="test-modal_container_content">
                    <CancelIcon onClick={close} className="test-modal_container_content_close" />
                <div className="test-modal_container_content_header">
                    <h4>{selectedTest ? messages.appointments.edit_test : messages.appointments.add_test}</h4>
                </div>
                <div className="test-modal_container_content_body">
                    <form>
                        <label htmlFor="code" className='required'>{messages.appointments.select_test}</label>
                        <div className="auto_complete">
                            <Autocomplete
                                id="combo-box-demo"
                                value={selectedLabtest}
                                onChange={(event, newValue) => {
                                    setSelectedLabtest(newValue.id);
                                }}
                                inputValue={inputValue}
                                onInputChange={(event, newInputValue) => {
                                    setInputValue(newInputValue);
                                }}
                                options={labsList}
                                getOptionSelected={(option) => option.id === selectedLabtest}
                                getOptionLabel={(option) => option.name || inputValue}
                                style={{ width: '100%' }}
                                renderInput={(params) => (
                                    <div ref={params.InputProps.ref}>
                                      <input placeholder={messages.appointments.select_test} type="text" id="testlab" {...params.inputProps} />
                                    </div>
                                  )}
                            />
                        </div>

                        <label htmlFor="suggession">{messages.appointments.suggession_recommendation}</label>
                        <textarea
                            id='suggession'
                            name="suggession"
                            placeholder={messages.appointments.suggession_recommendation_placeholder}
                            value={formData.notes}
                            onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                            rows={3}
                            ></textarea>
                        <div className="actions">
                                <button className="cancel" 
                                    onClick={(e) => {
                                        e.preventDefault();
                                        close();
                                        }}>
                                        {messages.patients.form.btn_cancel}                           
                                </button>
                                <button onClick={(e) =>  {
                                    e.preventDefault();
                                    save();
                                    }} >
                                    {messages.patients.form.btn_save}
                                </button>
                        </div>
                        <p id="feedback"><span style={{ background: '#FFF' }}>{feedBack}</span></p>
                    </form>   
                </div>
            </div>
            <ConfirmDialog show={showConfirmation} 
                     onCancel={() => setShowConfirmation(false)}
                     onConfirm={() => {
                        setShowConfirmation(false);
                        clear();
                        close();
                     }}
                     content={messages.warningMsgs.warning_close_window}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
        </div>
    );
}
export default injectIntl(SuggessionForm);
